// Centralised SEO / AEO / GEO / Entity / Reputation structured data for VSINDLPARK.COM
// All schema.org JSON-LD builders live here so they stay consistent across pages.

export const SITE_URL = "https://vsindlpark.in";
export const ORG_NAME = "VS Agro Infra Enterprises";
export const ORG_ALT = "VSINDLPARK";
// Keyword bank shared across schema entities (captures both SIIDCUL & SIIDCUL spellings + gap terms)
export const KEYWORDS = "industrial plots Kotdwar, SIIDCUL Kotdwar, SIIDCUL Kotdwar, Sigaddi Growth Centre, IIE Sigaddi plots, industrial land Uttarakhand, warehouse land Uttarakhand, logistics park plot Kotdwar, factory land near Delhi NCR, industrial plot price per sq meter Uttarakhand, Uttarakhand Industrial Policy 2023, Uttarakhand Logistics Policy 2023, SGST reimbursement Uttarakhand, MSME capital subsidy Uttarakhand, buy industrial land non-resident Uttarakhand, Delhi Dehradun Expressway industrial land";
export const LOGO_URL = `${SITE_URL}/logo192.png`;
export const PHONE_PRIMARY = "+91-9258959058";
export const PHONE_SECONDARY = "+91-9557877290";
export const EMAIL = "amritinfotech9@gmail.com";

// Reputation SEO — derived from on-site client testimonials.
// NOTE: Update ratingValue / reviewCount to match your verified Google Business reviews.
export const REVIEWS = [
  { author: "V.S. Choudhary", rating: 5, text: "Secured the perfect industrial plot in SIIDCUL Kotdwar. The team was professional and guided us through every step." },
  { author: "Rahul Agarwal", rating: 5, text: "Excellent infrastructure and accessibility. The entire process was smooth and hassle-free." },
  { author: "Rajeev Kumar", rating: 5, text: "Best location for setting up industry. Government incentives available made it even more attractive." },
];
export const AGGREGATE_RATING = { ratingValue: "5.0", reviewCount: "3", bestRating: "5", worstRating: "1" };

// AEO / GEO — concise, factual, citation-ready Q&A.
export const FAQS = [
  {
    q: "Where is VSINDLPARK industrial park located?",
    a: "VSINDLPARK is located at IIE Sigaddi, SIIDCUL Industrial Area, Kotdwar, Pauri Garhwal district, Uttarakhand (PIN 246149). It is developed and marketed by VS Agro Infra Enterprises.",
  },
  {
    q: "What plot sizes are available at IIE Sigaddi, Kotdwar?",
    a: "Industrial and commercial plots range from 500 sq.mtr up to 10,000 sq.mtr, suitable for manufacturing units, warehouses, and small-scale industries. Custom sizes can be discussed on enquiry.",
  },
  {
    q: "What is the price of industrial plots at SIIDCUL Kotdwar?",
    a: "Plots are offered at a flat ₹7,500 per sq.mtr across sizes from 500 to 10,000 sq.mtr. Final cost depends on the plot size you choose; corner and wider-road-frontage plots may carry standard SIIDCUL location charges.",
  },
  {
    q: "Are the plots SIDA / SIIDCUL approved?",
    a: "Yes. The plots are part of the SIDA-approved IIE Sigaddi industrial estate within the SIIDCUL Kotdwar area, with an approved site map and clear leasehold title.",
  },
  {
    q: "What is the lease tenure for the industrial plots?",
    a: "Plots are offered on a 90-year leasehold basis, which is the standard tenure for SIIDCUL industrial estates in Uttarakhand.",
  },
  {
    q: "What government subsidies and incentives are available?",
    a: "Eligible units can avail Uttarakhand industrial policy benefits including up to 15% capital subsidy, around 5% interest subsidy, stamp duty exemption, and MSME incentives. Benefits vary by industry category and investment size.",
  },
  {
    q: "What is the booking and payment plan?",
    a: "The typical plan is 10% at booking, 15% at allotment, and 75% at the time of the lease deed. A 10% earnest money deposit (EMD) can be calculated using the on-site EMD calculator.",
  },
  {
    q: "Is bank or NBFC financing available for the plots?",
    a: "Yes. Industrial plot purchases can be financed through banks such as SBI, PNB and BOB, as well as NBFCs offering industrial land and project loans.",
  },
  {
    q: "What industries can be set up at IIE Sigaddi Kotdwar?",
    a: "The estate supports light and medium manufacturing, warehousing, food processing, packaging, electronics, and other non-polluting industrial activities permitted under SIIDCUL norms.",
  },
  {
    q: "How well connected is Kotdwar for industrial logistics?",
    a: "Kotdwar is connected by rail and road to Delhi-NCR, Dehradun and Haridwar, making it a practical base for distribution across North India while benefiting from Uttarakhand's industrial incentives. It has its own railway station and lies on the improving Delhi-Dehradun corridor.",
  },
  {
    q: "Is SIIDCUL the same as SIIDCUL, and what is the Sigaddi Growth Centre?",
    a: "Yes. SIIDCUL (State Infrastructure & Industrial Development Corporation of Uttarakhand Ltd) is commonly written as SIIDCUL. The IIE Sigaddi estate at Kotdwar is officially part of the SIIDCUL Sigaddi Growth Centre, so 'SIIDCUL Kotdwar', 'SIIDCUL Kotdwar' and 'Sigaddi Growth Centre' all refer to the same industrial area where VSINDLPARK plots are located.",
  },
  {
    q: "How do Kotdwar industrial plot prices compare to Delhi NCR hubs?",
    a: "Kotdwar is dramatically cheaper. Plots here are just ₹7,500 per sq.mtr, whereas comparable industrial land in Delhi-NCR hubs like IMT Kharkhoda runs ₹39,000-60,000 per sq.mtr and UPSIDA nodes near Delhi are far higher. You get North India connectivity plus Uttarakhand tax incentives at a fraction of the NCR entry cost.",
  },
  {
    q: "Can outsiders or non-residents of Uttarakhand buy industrial land in Kotdwar?",
    a: "Yes. Uttarakhand's land-purchase restrictions apply mainly to agricultural land. Industrial plots allotted through SIIDCUL/SIDA estates such as IIE Sigaddi, Kotdwar are available to companies and investors from anywhere in India for setting up a bona-fide industrial or commercial unit.",
  },
  {
    q: "Can I build a warehouse or logistics park at IIE Sigaddi Kotdwar?",
    a: "Yes. Warehousing, cold storage and logistics facilities are permitted uses. Under the Uttarakhand Logistics Policy 2023 eligible projects can claim up to a 20% capital subsidy (with cold storage getting an additional benefit), making Sigaddi Growth Centre attractive for distribution hubs serving Delhi-NCR and the hills.",
  },
  {
    q: "What tax benefits apply under the Uttarakhand Industrial Policy?",
    a: "Eligible units can avail benefits such as capital investment subsidy, interest subsidy on term loans, 100% stamp duty exemption on the land deed, and net SGST reimbursement on eligible sales for a defined period. Exact percentages depend on the unit category and investment slab under the prevailing Uttarakhand industrial policy.",
  },
  {
    q: "Which industries are best suited to IIE Sigaddi Kotdwar?",
    a: "Food processing, packaging, FMCG, electronics assembly, auto components, pharma-allied, and light engineering units do particularly well here thanks to non-polluting zoning, water/power availability, and proximity to raw-material and consumer markets in North India.",
  },
];

export function buildOrganizationSchema(sameAs = []) {
  return {
    "@context": "https://schema.org",
    "@type": "RealEstateAgent",
    "@id": `${SITE_URL}/#organization`,
    name: ORG_NAME,
    alternateName: ORG_ALT,
    url: SITE_URL,
    logo: LOGO_URL,
    image: LOGO_URL,
    description:
      "VS Agro Infra Enterprises (VSINDLPARK) sells SIDA-approved industrial and commercial plots at IIE Sigaddi, SIIDCUL / SIIDCUL Sigaddi Growth Centre, Kotdwar, Uttarakhand — sizes from 500 to 10,000 sq.mtr on 90-year leasehold. Suitable for manufacturing, warehouse and logistics units with Uttarakhand Industrial Policy incentives.",
    keywords: KEYWORDS,
    telephone: PHONE_PRIMARY,
    email: EMAIL,
    priceRange: "₹₹",
    currenciesAccepted: "INR",
    address: {
      "@type": "PostalAddress",
      streetAddress: "IIE Sigaddi, SIIDCUL Industrial Area",
      addressLocality: "Kotdwar",
      addressRegion: "Uttarakhand",
      postalCode: "246149",
      addressCountry: "IN",
    },
    geo: { "@type": "GeoCoordinates", latitude: 29.7475, longitude: 78.5181 },
    areaServed: [
      { "@type": "Place", name: "Kotdwar" },
      { "@type": "Place", name: "Pauri Garhwal" },
      { "@type": "State", name: "Uttarakhand" },
      { "@type": "Place", name: "Delhi NCR" },
    ],
    contactPoint: {
      "@type": "ContactPoint",
      telephone: PHONE_PRIMARY,
      contactType: "sales",
      areaServed: "IN",
      availableLanguage: ["en", "hi"],
    },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: AGGREGATE_RATING.ratingValue,
      reviewCount: AGGREGATE_RATING.reviewCount,
      bestRating: AGGREGATE_RATING.bestRating,
      worstRating: AGGREGATE_RATING.worstRating,
    },
    review: REVIEWS.map((r) => ({
      "@type": "Review",
      author: { "@type": "Person", name: r.author },
      reviewRating: { "@type": "Rating", ratingValue: String(r.rating), bestRating: "5" },
      reviewBody: r.text,
    })),
    sameAs: sameAs.filter(Boolean),
  };
}

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  url: SITE_URL,
  name: "VSINDLPARK.COM",
  alternateName: "VS Agro Infra Enterprises Industrial Park",
  description:
    "Premium SIDA-approved industrial, warehouse and logistics plots at IIE Sigaddi, SIIDCUL / SIIDCUL Sigaddi Growth Centre, Kotdwar, Uttarakhand.",
  keywords: KEYWORDS,
  inLanguage: "en-IN",
  publisher: { "@id": `${SITE_URL}/#organization` },
};

export const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  name: "Industrial, Warehouse & Commercial Plots at IIE Sigaddi, SIIDCUL / SIIDCUL Kotdwar",
  description:
    "SIDA-approved industrial, warehouse and commercial plots from 500 to 10,000 sq.mtr on 90-year leasehold at IIE Sigaddi, Sigaddi Growth Centre, Kotdwar, Uttarakhand — at a flat ₹7,500/sq.mtr with Uttarakhand Industrial Policy incentives.",
  category: "Industrial Real Estate",
  keywords: KEYWORDS,
  brand: { "@type": "Brand", name: ORG_ALT },
  offers: {
    "@type": "AggregateOffer",
    priceCurrency: "INR",
    lowPrice: "7500",
    highPrice: "7500",
    offerCount: "45",
    unitText: "per square metre",
    availability: "https://schema.org/InStock",
    seller: { "@id": `${SITE_URL}/#organization` },
  },
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: AGGREGATE_RATING.ratingValue,
    reviewCount: AGGREGATE_RATING.reviewCount,
  },
};

export function buildFaqSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}

export function buildBreadcrumbSchema(page) {
  const items = [{ name: "Home", url: SITE_URL }];
  if (page && page !== "home") {
    const label = page.charAt(0).toUpperCase() + page.slice(1);
    items.push({ name: label, url: `${SITE_URL}/${page}` });
  }
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: it.url,
    })),
  };
}
